(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["er-catalog-review"]) return;
  try {
    
  if (!customElements.get('er-native-catalog-review')) {
    customElements.define('er-native-catalog-review', class extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.select = this.querySelector('[data-er-review-select]');
        if (!this.select) return;
        this.select.value = '';
        this.onSelectionChange = () => this.renderSelection();
        this.select.addEventListener('change', this.onSelectionChange);
        this.renderSelection();
      }

      disconnectedCallback() {
        if (this.select && this.onSelectionChange) {
          this.select.removeEventListener('change', this.onSelectionChange);
        }
      }

      renderSelection() {
        const panels = Array.from(this.querySelectorAll('[data-er-review-details]'));
        const prompt = this.querySelector('[data-er-review-prompt]');
        panels.forEach((panel) => { panel.hidden = true; });
        if (!prompt) return;
        prompt.hidden = false;
        const productId = this.dataset.productId;
        const variantId = this.select?.value;
        if (!/^[1-9][0-9]*$/.test(productId || '') || productId !== this.dataset.pageProductId) return;
        if (!/^[1-9][0-9]*$/.test(variantId || '')) return;
        const options = Array.from(this.select.options).filter((option) => option.value === variantId);
        const matches = panels.filter((panel) => panel.dataset.variantId === variantId);
        if (options.length !== 1 || matches.length !== 1 || matches[0].dataset.productId !== productId) return;
        matches[0].hidden = false;
        prompt.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-generation-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('er-generation-selector')) {
    class ERGenerationSelector extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('[data-er-slider]');
        this.dots = this.querySelector('[data-er-dots]');
        if (!this.slider || !this.dots) return;

        this.onScroll = () => window.requestAnimationFrame(() => this.updateDots());
        this.slider.addEventListener('scroll', this.onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.buildDots());
          this.resizeObserver.observe(this.slider);
        }

        this.buildDots();
      }

      disconnectedCallback() {
        if (this.slider && this.onScroll) this.slider.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      pageCount() {
        const width = this.slider.clientWidth;
        if (!width || this.slider.scrollWidth <= width + 1) return 0;
        return Math.ceil(this.slider.scrollWidth / width);
      }

      buildDots() {
        const pages = this.pageCount();
        if (pages === this.dots.childElementCount) {
          this.updateDots();
          return;
        }

        this.dots.textContent = '';
        this.dots.hidden = pages < 2;
        const label = this.getAttribute('data-er-dot-label') || '';

        for (let index = 0; index < pages; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'er-generation-selector__dot';
          dot.setAttribute('aria-label', (label + ' ' + (index + 1)).trim());
          dot.addEventListener('click', () => {
            this.slider.scrollTo({ left: index * this.slider.clientWidth, behavior: 'smooth' });
          });
          this.dots.appendChild(dot);
        }

        this.updateDots();
      }

      updateDots() {
        const dots = Array.from(this.dots.children);
        if (!dots.length) return;
        const width = this.slider.clientWidth || 1;
        const index = Math.min(dots.length - 1, Math.round(this.slider.scrollLeft / width));
        dots.forEach((dot, position) => dot.classList.toggle('is-active', position === index));
      }
    }

    customElements.define('er-generation-selector', ERGenerationSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-model-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('er-model-finder')) {
    class ERModelFinder extends HTMLElement {
      connectedCallback() {
        if (this.erReady) {
          this.showStep(1, false);
          return;
        }
        this.erReady = true;
        this.stepPanels = Array.from(this.querySelectorAll('[data-er-step-panel]'));
        this.modelPanels = Array.from(this.querySelectorAll('[data-er-models]'));
        this.progress = this.querySelector('[data-er-progress]');

        this.querySelectorAll('[data-er-part]').forEach((part) => {
          part.addEventListener('click', (event) => {
            event.preventDefault();
            this.showPart(part.getAttribute('data-er-part'));
          });
        });

        this.querySelectorAll('[data-er-reset]').forEach((button) => {
          button.addEventListener('click', () => this.showStep(1, true));
        });

        this.classList.add('er-model-finder--ready');
        this.showStep(1, false);
      }

      showPart(index) {
        this.modelPanels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.getAttribute('data-er-models') === index);
        });
        this.showStep(2, true);
      }

      showStep(step, moveFocus) {
        const key = String(step);
        this.setAttribute('data-er-step', key);
        this.stepPanels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.getAttribute('data-er-step-panel') === key);
        });
        if (this.progress) {
          this.progress.style.width = key === '2' ? '100%' : '50%';
        }
        if (moveFocus) {
          const target = this.querySelector('[data-er-step-panel="' + key + '"] [data-er-focus]');
          if (target) target.focus();
        }
      }
    }

    customElements.define('er-model-finder', ERModelFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-native-advisory-cart"]) return;
  try {
    
  if (!customElements.get('er-native-advisory-cart')) {
    customElements.define('er-native-advisory-cart', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[name="checkout"]');
        this.form = this.querySelector('[data-native-checkout-form]');
        this.updateForm = this.querySelector('[data-native-update-form]');
        if (!this.updateForm && !this.form) return;
        this.abort?.abort();
        this.abort = new AbortController();
        this.addEventListener('input', () => this.refresh(), { signal: this.abort.signal });
        this.updateForm?.addEventListener('submit', (event) => {
          if (this.dataset.commerceVersion !== 'er-native-advisory/1' || this.dataset.previewOnly !== 'false') event.preventDefault();
        }, { signal: this.abort.signal });
        this.form?.addEventListener('submit', (event) => {
          this.refresh();
          if (!this.button || this.button.disabled) event.preventDefault();
        }, { signal: this.abort.signal });
        this.refresh();
      }
      disconnectedCallback() { this.abort?.abort(); }
      refresh() {
        if (!this.button) return;
        const dirty = Array.from(this.querySelectorAll('[name="updates[]"]')).some((input) => input.value !== input.defaultValue);
        this.button.disabled = dirty || this.dataset.commerceVersion !== 'er-native-advisory/1' || this.dataset.allowed !== 'true' || this.dataset.previewOnly !== 'false';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-support-intro"]) return;
  try {
    
  class EarbudsRestoreHelpPart extends HTMLElement {
    connectedCallback() {
      if (this.partAbort) return;
      this.partAbort = new AbortController();
      this.partWindow = this.ownerDocument.defaultView;
      this.partWindow?.addEventListener('hashchange', () => this.renderPart(), { signal: this.partAbort.signal });
      this.renderPart();
    }

    disconnectedCallback() {
      this.partAbort?.abort();
      this.partAbort = null;
    }

    renderPart() {
      const output = this.querySelector('[data-er-help-part-label]');
      const hash = this.partWindow?.location.hash || '';
      const labels = {
        '#er-part=earbud_L': this.dataset.labelLeft,
        '#er-part=case': this.dataset.labelCase,
        '#er-part=earbud_R': this.dataset.labelRight,
      };
      const label = Object.hasOwn(labels, hash) ? labels[hash] : '';
      if (output) output.textContent = label || '';
      this.hidden = !output || !label;
    }
  }

  if (!customElements.get('er-help-part')) {
    customElements.define('er-help-part', EarbudsRestoreHelpPart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-upsell-set"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('er-upsell-set')) {
    class ERUpsellSet extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.onClick = (event) => {
          const button = event.target.closest('[data-er-upsell-add]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          this.addToCart(button);
        };
        this.addEventListener('click', this.onClick);

        if (
          typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.variantChange
        ) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.refresh(event));
        }
      }

      disconnectedCallback() {
        if (this.onClick) this.removeEventListener('click', this.onClick);
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
        this.bound = false;
      }

      addToCart(button) {
        const variantId = button.getAttribute('data-er-variant-id');
        if (!variantId) return;
        button.disabled = true;

        const cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              };

        const body = { id: Number(variantId), quantity: 1 };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(body);

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) return;
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'er-upsell-set',
                productVariantId: variantId,
                cartData: response,
              });
            }
          })
          .catch(() => {})
          .finally(() => {
            button.disabled = false;
          });
      }

      refresh(event) {
        const sectionId = this.getAttribute('data-er-upsell-section');
        const variant = event && event.data && event.data.variant;
        if (!sectionId) return;
        if (!variant || !variant.id) {
          this.textContent = '';
          this.hidden = true;
          return;
        }

        fetch(window.location.pathname + '?variant=' + variant.id + '&section_id=' + sectionId)
          .then((response) => response.text())
          .then((html) => {
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('er-upsell-set');
            if (!fresh) {
              this.textContent = '';
              this.hidden = true;
              return;
            }
            this.innerHTML = fresh.innerHTML;
            this.hidden = fresh.hasAttribute('hidden');
          })
          .catch(() => {});
      }
    }

    customElements.define('er-upsell-set', ERUpsellSet);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  if (window.__erCookiePreferencesBound) return;
  window.__erCookiePreferencesBound = true;
  var RETRY_MS = 200;
  var DEADLINE_MS = 5000;
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-er-cookie-preferences]');
    if (!button || button.disabled || window.__erCookiePreferencesInFlight) return;
    if (window.Shopify && window.Shopify.designMode) {
      var editorStatus = button.parentElement.querySelector('[data-er-cookie-preferences-status]');
      if (editorStatus) editorStatus.textContent = button.dataset.editorNotice;
      return;
    }
    window.__erCookiePreferencesInFlight = true;
    var status = button.parentElement ? button.parentElement.querySelector('[data-er-cookie-preferences-status]') : null;
    var retryTimer = null;
    var deadlineTimer = null;
    var finished = false;
    button.disabled = true;
    if (status) status.textContent = button.dataset.opening;
    function finish(ok) {
      if (finished) return;
      finished = true;
      if (retryTimer !== null) clearTimeout(retryTimer);
      if (deadlineTimer !== null) clearTimeout(deadlineTimer);
      window.__erCookiePreferencesInFlight = false;
      button.disabled = false;
      if (!button.isConnected) return;
      if (status) status.textContent = ok ? '' : button.dataset.unavailable;
    }
    deadlineTimer = setTimeout(function () { finish(false); }, DEADLINE_MS);
    function attempt() {
      if (finished) return;
      if (!button.isConnected) {
        finish(false);
        return;
      }
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        try {
          Promise.resolve(window.privacyBanner.showPreferences()).then(
            function () { finish(true); },
            function () { finish(false); }
          );
        } catch (error) {
          finish(false);
        }
      } else {
        retryTimer = setTimeout(attempt, RETRY_MS);
      }
    }
    attempt();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
